module.exports = __webpack_public_path__ + "img/inspection.0d67404b.svg";